var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8357 12.9729C36.6234 13.1487 37.8267 13.5461 38.7248 14.4443C40.3357 16.0552 40.3357 18.6479 40.3357 23.8333C40.3357 29.0188 40.3357 31.6115 38.7248 33.2224C37.1139 34.8333 34.5212 34.8333 29.3357 34.8333H20.169C14.9836 34.8333 12.3909 34.8333 10.78 33.2224C9.88182 32.3243 9.48443 31.121 9.30859 29.3333",
    stroke: "#0B847E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66797 18.3333C3.66797 13.1478 3.66797 10.5551 5.27888 8.94416C6.88979 7.33325 9.48252 7.33325 14.668 7.33325H23.8346C29.0201 7.33325 31.6128 7.33325 33.2237 8.94416C34.8346 10.5551 34.8346 13.1478 34.8346 18.3333C34.8346 23.5187 34.8346 26.1114 33.2237 27.7223C31.6128 29.3333 29.0201 29.3333 23.8346 29.3333H14.668C9.48252 29.3333 6.88979 29.3333 5.27888 27.7223C3.66797 26.1114 3.66797 23.5187 3.66797 18.3333Z",
    stroke: "#004945",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8346 18.3333C23.8346 20.8646 21.7826 22.9167 19.2513 22.9167C16.72 22.9167 14.668 20.8646 14.668 18.3333C14.668 15.802 16.72 13.75 19.2513 13.75C21.7826 13.75 23.8346 15.802 23.8346 18.3333Z",
    stroke: "#004945",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.332 22L29.332 14.6667",
    stroke: "#0B847E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16797 22L9.16797 14.6667",
    stroke: "#0B847E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankLogo);
export default __webpack_public_path__ + "static/media/bankLogo.627e35d62b1bddc4cbdd1f44802f99d5.svg";
export { ForwardRef as ReactComponent };